<template>
  <div class="modal-body">
    <ul class="nav-step mv-30 ph-80">
      <!--<li class="checked">-->
      <li v-for="(item, index) in data.steps" :key="index" :class="[selectedStep(item)]">
        <i>{{item.id}}</i>{{item.name}}
      </li>
    </ul>
    <keep-alive>
      <component ref="child" :is="selectComponent" @changeStep="changeStep" :item="data.steps[selectIndex-1]"
      :items="data.steps" :data.sync="data.data" :tos="data.tos" :checkList="data.checkList" :isEmployee="data.isEmployee" :reserve="data.reserve"/>
    </keep-alive>
  </div>
</template>

<script>
import SelectTicket from './SelectTicket.vue'
import Agree from './Agree.vue'
import InOutCheckList from './InOutCheckList.vue'
import EnterInfo from './EnterInfo.vue'
export default {
  components:{
    SelectTicket,
    Agree,
    InOutCheckList,
    EnterInfo
  },
  computed: {

    selectComponent(){
      if(this.data.steps){

        return _.find(this.data.steps, {id: this.selectIndex}).component;
      }else{
        return null
      }
    },
    selectedStep(){
      return (item) => {
        if(this.data.steps){
          var o = _.find(this.data.steps, {id: item.id});
          if(o.id == this.selectIndex){
            return 'on';
          }
          if(o.id < this.selectIndex){
            return 'checked';
          }
        }else{
          return ''
        }
      }
    }
  },
  props: {

    data: {
      type: Object,
      default: () => { return {steps: [], data: null, tos: [], checkList: []}}
    },

  },
  data(){
    return{
      selectIndex: 1,
    }
  },
  mounted(){
    this.init();
  },
  methods: {
    init(){
      this.$nextTick(()=>{

      })
      //this.setStep();
    },
    changeStep(o){
      this.selectIndex = o.item.id + o.action;
      if(o.action > 0){
        this.data.tos = o.tos;
        this.data.checkList = o.checkList;
        if(!this.data.data.visitTypeCode) this.data.data.changedVisitTypeCode = o.visitTypeCode;
      }
    },
    getData(data){
      return data;
    }
  }

}
</script>

<style>

</style>
